import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  SET_ALL_JOURNEY: 'SET_ALL_JOURNEY',
  SET_VIBE: 'SET_VIBE',

  POST: 'NOTIFICATION_HOME_POST',
  POST_SUCCESS: 'NOTIFICATION_HOME_POST_SUCCESS',
  POST_FAILURE: 'NOTIFICATION_HOME_POST_FAILURE',

  INVALIDATE_ITEM: 'NOTIFICATION_HOME_INVALIDATE_ITEM',
};

export const post = actions.post(() => `${BASE_URL}/notification/notification-home/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const setVibe = payload => dispatch => {
  dispatch({
    type: ACTIONS.SET_VIBE,
    payload,
  });
};

// this action creator belongs to Context api
export const setAllJourneys = journeys => ({
  type: ACTIONS.SET_ALL_JOURNEY,
  allJourney: journeys,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
